/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReadOnlyOBUType,
    ReadOnlyOBUTypeFromJSON,
    ReadOnlyOBUTypeFromJSONTyped,
    ReadOnlyOBUTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse20036
 */
export interface InlineResponse20036 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20036
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20036
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20036
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ReadOnlyOBUType>}
     * @memberof InlineResponse20036
     */
    results: Array<ReadOnlyOBUType>;
}

export function InlineResponse20036FromJSON(json: any): InlineResponse20036 {
    return InlineResponse20036FromJSONTyped(json, false);
}

export function InlineResponse20036FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20036 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ReadOnlyOBUTypeFromJSON)),
    };
}

export function InlineResponse20036ToJSON(value?: InlineResponse20036 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(ReadOnlyOBUTypeToJSON)),
    };
}


